import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { getBase64 } from '../../utils/utils.fuctions';
import { AlertService } from '../../services/alert.service';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
})
export class ImageComponent implements OnInit {
    @ViewChild('fileInput') fileInput!: ElementRef;
    public imageChangedEvent: any = '';
    public croppedImage: any = '';
    public imageBase64: string | ArrayBuffer | null = '';
    public messageMax: string = 'Tamaño máximo de imagen';
    public messageError: string = 'Error al procesar la imagen';
    public maxSizeKB: number = 2048; // 2MB por defecto
    public realSize: number;
    public errorSize: boolean = false;

    public get bytesToMB(): string {
        return (this.realSize / (1024 * 1024)).toFixed(2) || '0';
    }

    constructor(public dialogRef: MatDialogRef<ImageComponent>, private sanitizer: DomSanitizer, @Inject(MAT_DIALOG_DATA) public data: any, private alertService: AlertService) {}
    ngOnInit(): void {
        // Validar que data no sea null antes de acceder a sus propiedades
        if (this.data) {
            this.messageMax = this.data.messageMax || 'Tamaño máximo de imagen';
            this.maxSizeKB = this.data.maxSizeKB || 2048; // 2MB por defecto
            this.messageError = this.data.messageError || 'Error al procesar la imagen';
        } else {
            // Valores por defecto si data es null
            this.messageMax = 'Tamaño máximo de imagen';
            this.maxSizeKB = 2048; // 2MB por defecto
            this.messageError = 'Error al procesar la imagen';
        }
    }
    triggerFileInput(): void {
        this.fileInput.nativeElement.click();
    }
    fileChangeEvent(event: any): void {
        const file = event.target.files[0];
        if (file && file.size > this.maxSizeKB * 1024) {
            this.alertService.openDangerNotification('Error', this.messageError);
            this.errorSize = true;
            return;
        }
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        if ((event.blob?.size ?? 0) > this.maxSizeKB * 1024) {
            this.alertService.openDangerNotification('Error', this.messageError);
            this.errorSize = true;
            return;
        }
        this.errorSize = false;
        this.realSize = event.blob?.size ?? 0;
        this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl!);
        getBase64(event.blob!).then((res) => (this.imageBase64 = res));
    }
    onSaveClick(): void {
        this.dialogRef.close(this.imageBase64);
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
}
